export default "__VITE_ASSET__BvJYaeuQ__"